/*
 * @description: some helpful functions for data dealing
 * @author: Jason Wong
 * @since: 2019-07-12 10:50:08
 */

import { uuid } from "./uuid";

/**
 * copy data from source to dest
 * @param {Object} source
 * @param {Object} dest
 * @param  {...any} excludes
 */
function copy(source, dest, ...excludes) {
  for (let attrName in source) {
    if (!excludes.includes(attrName) && dest.hasOwnProperty(attrName)) {
      dest[attrName] = source[attrName];
    }
  }
}

/**
 *
 * @param {Object} source
 * @param {Array<String>} fieldNames
 */
function copyFields(source, fieldNames) {
  if (!source) return null;

  let res = {};
  for (const attr in source) {
    if (fieldNames.indexOf(attr) > -1) {
      res[attr] = source[attr];
    }
  }
  return res;
}

let loadingIdMap = {};
/**
 * 非阻塞加载方法，用来处理如下场景：
 * 当需要向服务器请求数据，但又不想阻塞当前用户操作的时候时候
 * @param {String} symbolName 加载动作唯一名称
 * @param {Function} loader 数据加载逻辑
 * @param {Function} dataSetter 数据处理逻辑，数据处理完成时调用
 * @param {Function} stateSetter 加载状态处理逻辑，当数据开始加载或者加载完成时调用
 */
async function nonBlockingload(symbolName, loader, dataSetter, stateSetter) {
  let curLoadingId = (loadingIdMap[symbolName] = uuid());
  let isLoading = true;
  setTimeout(() => {
    if (isLoading && loadingIdMap[symbolName] == curLoadingId) {
      stateSetter(true);
    }
  }, 500);
  try {
    const data = await loader();
    if (loadingIdMap[symbolName] == curLoadingId) {
      await dataSetter(data);
    }
  } catch (err) {
    if (loadingIdMap[symbolName] == curLoadingId) {
      throw err;
    }
  } finally {
    isLoading = false;
    if (loadingIdMap[symbolName] == curLoadingId) {
      stateSetter(false);
    }
  }
}

/**
 * 与nonBlockingload方法配合时候，用来标记加载动作无效
 * @param  {...any} symbolNames
 */
function invalidateLoading(...symbolNames) {
  for (const symbolName of symbolNames) {
    loadingIdMap[symbolName] = uuid();
  }
}

export { copy, copyFields, nonBlockingload, invalidateLoading };
